import { useEffect, useRef } from 'react';
import { useProgressSummary } from './use-progress-summary';
import { usePricingRanges, type PricingRange } from './use-pricing-ranges';
import { fireConfetti } from '@/utils/confetti';

function currentTier(total: number, ranges: PricingRange[]): number {
  let idx = -1;
  for (let i = 0; i < ranges.length; i++) {
    if (total >= ranges[i]!.range_min) idx = i;
  }
  return idx;
}

// Fires confetti when the user crosses a pricing-range milestone (tramo)
// during the session. The first observation seeds `lastTier` without
// firing, so reloads or initial mounts don't trigger false celebrations.
export function useTramoConfetti(): void {
  const { data } = useProgressSummary();
  const { data: rangesData } = usePricingRanges();
  const lastTier = useRef<number | null>(null);

  useEffect(() => {
    const ranges = rangesData?.ranges;
    if (!data || !ranges || ranges.length === 0) return;
    const tier = currentTier(data.total.total, ranges);
    if (lastTier.current !== null && tier > lastTier.current) {
      fireConfetti();
    }
    lastTier.current = tier;
  }, [data, rangesData]);
}
